import React, { forwardRef, type HTMLInputAutoCompleteAttribute } from "react"
import classNames from "classnames"

export interface InputProps
  extends Omit<
    React.ComponentPropsWithoutRef<"input">,
    "className" | "onChange" | "size" | "type" | "value"
  > {
  autoComplete?: HTMLInputAutoCompleteAttribute
  disabled?: boolean
  id: string
  label?: string
  name?: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  placeholder?: string
  readOnly?: boolean
  required?: boolean
  size?: "md" | "sm"
  type?: "email" | "number" | "password" | "search" | "tel" | "text" | "url"
  value: string
  wrapperClassName?: string
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      autoComplete = "on",
      disabled = false,
      id,
      label = "",
      name = "",
      onChange,
      placeholder = "",
      readOnly = undefined,
      required = false,
      size = "md",
      type = "text",
      value,
      wrapperClassName,
      ...props
    },
    ref,
  ) => {
    return (
      <div className={classNames("dds-field-wrapper", wrapperClassName)}>
        {label && (
          <label htmlFor={id}>
            {label}
            {required && <span className="c-ruby"> *</span>}
          </label>
        )}
        <input
          {...props}
          className={classNames(
            "text-input",
            size === "sm" && "sm-input",
            readOnly && "pe-n",
          )}
          autoComplete={autoComplete}
          disabled={disabled}
          id={id}
          name={name || id}
          onChange={(e) => typeof onChange === "function" && onChange(e)}
          placeholder={placeholder}
          ref={ref}
          readOnly={readOnly}
          required={required}
          type={type}
          value={value}
        />
      </div>
    )
  },
)

Input.displayName = "Input"
